import { useQuery } from '@tanstack/react-query';
import { fetchCaseRedFlags } from '../api/redFlags';

/**
 * Fetches all red-flag details for a case.
 * Returns { summaries, rf01_details, rf02_details, rf03_details, rf04_details }
 */
export const useCaseRedFlags = (caseNumber) => {
  return useQuery({
    queryKey: ['case-red-flags', caseNumber],
    queryFn: () => fetchCaseRedFlags(caseNumber),
    enabled: Boolean(caseNumber),
    staleTime: 60_000,
  });
};
